export default {
  headerContent: {
    title: 'Bereket Sigorta Nakliyat Sigortası Fiyatları',
    slogan: "Nakliyat Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'NAKLİYAT SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Bereket Sigorta Nakliyat (Emtea) Sigortası Nedir?',
    description: {
      title: 'Bereket Sigorta Seyahat Sağlık Sigortası Nedir? ',
      content: [
        'Emtea taşırken beraberinde riskte taşıdığınızı biliyor muydunuz?',
        'Emteayı alış noktasından varış noktasına kadar birçok riskle karşılaşa bilirsiniz. Bu riskler yangın, hırsızlık ve su hasarları olarak sıralanabilir. Bereket sigorta nakliyat sigortası yük taşıma esnasında oluşabilecek riskleri teminat altına alarak sigortalıya koruma sağlamaktadır.'
      ]
    },
    subContent: {
      title: 'Bereket Sigorta Nakliyat Sigortası Türleri Nedir?',
      content: [
        {
          paragraph:
            'Nakliyat sigortasında düzenlenmekte olan 4 adet poliçe çeşidi bulunmaktadır.',
          subList: [
            'Kati Poliçe',
            'Flotan Poliçe(Geçici)',
            'Abonman Poliçe',
            'Blok Poliçe'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Nakliyat Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Nakliyat Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Nakliyat Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Nakliyat Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Nakliyat Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Bereket Sigorta Nakliyat Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Kati Poliçe Nedir?',
      content: [
        {
          paragraph:
            'Kati poliçe, sevkiyata ait araç bilgileri, sefer tarihi, emtea bedeli ve sevk başlangıç ve bitiş yerinin belirli olduğu takdirde düzenlenen poliçedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Flotan Poliçe Nedir?',
      content: [
        {
          paragraph:
            'Flotan diğer adıyla geçici poliçe, araç bilgileri, sefer tarihi, emtea bedeli ve sevk başlangıç ve bitiş yerinin belirli olmadığı durumlarda düzenlenen poliçedir. Sevk bilgileri netlik kazandığı zamanda kati poliçe düzenlenmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Abonman Poliçe Nedir?',
      content: [
        {
          paragraph:
            'Abonman poliçe, bir yıl içerisinde yapılacak olan tüm sevkiyatları için uygulanacak fiyat ve şartları, tarafların yükümlülüklerinin bulunduğu poliçedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Blok Poliçe Nedir?',
      content: [
        {
          paragraph:
            'Blok poliçe, sigortalının 1 yıl içerinde taşıyacağı emtea’nın bedeli üzerinden düzenlenen poliçedir. 1 yıl içerinde yapacağı sevkiyatlar poliçe başlangıcında belirlenmiş olan sigorta bedeline kadar güvence altındadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Nakliyat Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph:
            'Nakliyat sigortasında ana ve ek teminatlar bulunmaktadır.',
          subList: null
        },
        {
          paragraph: 'Bu teminatlar;',
          subList: null
        },
        {
          paragraph: 'Tam Ziya',
          subList: null
        },
        {
          paragraph: 'Dar Teminat',
          subList: null
        },
        {
          paragraph: 'Geniş Teminat',
          subList: null
        },
        {
          paragraph: 'Tam Ziya Teminatı Nedir?',
          subList: null
        },
        {
          paragraph:
            'Taşıma aracı ve malın tüm değerini kaybedecek derece hasar görmesini halinde karşılık verilen teminattır.',
          subList: null
        },
        {
          paragraph: 'Dar Teminat Nedir?',
          subList: null
        },
        {
          paragraph:
            'Dar teminat malın ve taşıma aracının uğrayacağı kısmı hasarlar sonucu çıkan masrafları teminat altına almaktadır.',
          subList: null
        },
        {
          paragraph: 'İsteğe Bağlı Ek Teminatlar;',
          subList: ['Yükleme, aktarma, boşaltma', 'Hırsızlık', 'Islanma']
        },
        {
          paragraph: 'Geniş Teminat Nedir?',
          subList: null
        },
        {
          paragraph:
            'Geniş teminat ile taşınan malda taşıma esnasında oluşacak kaza veya olay neticesindeki maddi kayıplara karşı güvence sağlamaktadır.',
          subList: null
        },
        {
          paragraph: 'İsteğe Bağlı Ek Teminatlar',
          subList: [
            'Harp Teminatı',
            'Savaş',
            'İç savaş',
            'İhtilal, ayaklanma',
            'Başkaldırma',
            'İç kargaşa',
            'Grevcilerin, lokavt edilmiş işçilerin',
            'İş uyuşmazlığına, işçi ayaklanmasına veya halk hareketlerine katılan kişilerin Teröristlerin, Politik nedenlerle hareket eden kişilerin sigorta konusuna verdiği zarar teminata dahildir.'
          ]
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Nakliyat Poliçesi Düzenlenirken Talep Edilen Bilgiler Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Firma ise vergi kimlik numarası, şahıs ise TC numarası.',
            'Sevk başlangıç ve bitiş noktası.',
            'Sevk Başlangıç ve bitiş tarihleri.',
            'Sevki gerçekleştirecek araç bilgileri.',
            'Emtea Türü.',
            'Emtea Bedeli.'
          ]
        }
      ]
    },
    {
      title:
        'Bereket Sigorta Nakliyat Poliçesi Hasar Anında Talep Edilen Belge/Bilgiler Nelerdir?',
      content: [
        {
          paragraph:
            'Hasar anında istenen bilgi ve belgeler hasar boyutuna göre değişmektedir.',
          subList: null
        },
        {
          paragraph: 'Genel olarak aşağıdaki bilgi ve belgeler istenmektedir.',
          subList: [
            'Poliçe numarası',
            'Hasar tarihi',
            'Tahmini hasar miktarı',
            'Sigortalının veya irtibat kurulacak kişinin iletişim bilgisi'
          ]
        }
      ]
    },
    {
      title: 'Bereket Sigorta’dan Neden Nakliyat Sigortası Almalıyım?',
      content: [
        {
          paragraph:
            'Sattığınız veya almış olduğunuz emteaların taşıma esnasında oluşabilecek hasarlara karşı almış olduğunuz güvenlik önlemleri her ne kadar yeterli görülse bile her zaman yeterli değildir.  Kimi zaman dış etmenler kaynaklı olsun kimi zaman iç etmenlerden kaynaklı olsun hasar meydana gelebiliyor. Nakliyat sigortası sizin fark edemediniz birçok riske karşı emteanızı koruma altına almaktadır. Sağladığı bu koruma ile sigortalıyı maddi kayıplara karşı güvence altında tutmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Nakliyat Sigortası Yaptırmak Zorunlu Mudur?',
      content: [
        {
          paragraph: 'Nakliyat sigortası zorunlu olmayan bir sigorta ürünüdür.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Nakliyat Sigortası Kim Tarafından Yaptırılır?',
      content: [
        {
          paragraph:
            'Nakliyat sigortasını ister alan, satan veya yüklenici kişi veya kurum tarafında yaptırılabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Nakliyat Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            'Nakliyat sigortası fiyatları, taşınan malın türü, taşıdığı risk oranı ve adedine göre değişmektedir. Bu nedenle nakliyat sigortaları özel olarak düzenlenmekte olup sabit bir fiyatı yoktur.',
          subList: null
        }
      ]
    },
    {
      title: 'Bereket Sigorta Nakliyat Sigortası Teklifi Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Nakliyat sigortası teklifi, sigorta acentesinden, brokerden veya sigorta şirketinden alınabilmektedir. ',
          subList: null
        },
        {
          paragraph:
            'Alokasko.com olarak ihtiyacınız olan nakliyat sigortası teklifini size en uygun teminatlar hazırlayarak sunmaktayız. ',
          subList: null
        },
        {
          paragraph:
            'Bereket sigorta nakliyat sigortasını alokasko.com güvencesi ile almak için başvuru formunda yer alan bilgileri doldurmanız yeterlidir. Doldurmuş olduğunuz form sayesinde uzman danışmanlarımız sizin için en uygun teklifi hazırlayarak size sunmaktadır. Sunulan bu teklifi değerlendirebilir, kafanıza takılan sorular hakkında bilgi alabilir ve poliçe tanzimi sağlayabilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
